<template>
    <van-dialog v-model="isVisibility"
        :show-confirm-button="false"
        :styles="{top: '100px'}">
        <div class="diyModal">
            <div class="diyModalBg"
                :class="awardObj.bigWheelActivityType == '3' ? 'tiger-modal-bg' : 'other-modal-bg'">
                <img :src="diyModalBg[awardObj.bigWheelActivityType-1]">
            </div>
            <div class="awardContent">
                <div style="font-size: 26px; padding: 30px 0 10px;">恭喜您获得</div>
                <div style="color: #999999; font-size: 16px;">{{awardObj.pointValue}}积分</div>
                <div v-if="awardObj.singleFlag && awardObj.jumpType === '1'"
                    style="text-align: center; color: #999999; margin: 15px 0 0 0;">点击确认返回Hi荣耀首页</div>
            </div>
            <div class="diyReceive">
                <div class="diyModalButton"
                    :class="{'blindBoxBtn': awardObj.bigWheelActivityType == '2'}">
                    <img v-if="awardObj.bigWheelActivityType == '1' && !activityObj.extendConfig.awardPopupButtonColor"
                        src="static/runtime/images/magic/award/diyModalButton.png" />
                    <img v-if="awardObj.bigWheelActivityType == '4' && !activityObj.extendConfig.awardPopupButtonColor"
                        src="static/runtime/images/magic/award/diyModalButton.png" />
                    <img v-if="awardObj.bigWheelActivityType == '3' && !activityObj.extendConfig.awardPopupButtonColor"
                        :class="awardObj.bigWheelActivityType == '3' ? 'tiger-btn-img':''"
                        src="static/runtime/images/magic/award/tiger-btn.png" />
                    <div v-if="awardObj.bigWheelActivityType == '1' && activityObj.extendConfig.awardPopupButtonColor"
                        class="diyModalButtonBg"
                        :style=getButtonBgStyle></div>
                    <div v-if="awardObj.bigWheelActivityType == '3' && activityObj.extendConfig.awardPopupButtonColor"
                        class="diyModalButtonBg"
                        :style=getButtonBgStyle></div>
                    <div v-if="awardObj.bigWheelActivityType == '2'"
                        class="diyModalButtonBg"
                        :style=getButtonBgStyle></div>
                    <div class="diyModalButtonText">
                        <div v-if="!awardObj.singleFlag"
                            :class="awardObj.bigWheelActivityType == '3' ? 'tiger-btn': ''"
                            @click="modalCancel">我知道了</div>
                        <div v-if="awardObj.singleFlag"
                            :class="awardObj.bigWheelActivityType == '3' ? 'tiger-btn': ''"
                            @click="nextStep(awardObj.jumpUrl,awardObj.jumpType)">{{ modalButtonText }}</div>
                    </div>
                </div>
            </div>
            <div class="diyClose"
                @click="modalCancel"><van-icon name="close" /></div>
        </div>
    </van-dialog>
</template>


<script>
import { Dialog, Icon } from 'vant';
export default {
  components: {
    [Dialog.Component.name]: Dialog.Component,
    [Icon.name]: Icon,
  },
  props: {
    awardObj: Object,
    activityObj: Object,
    modalButtonText: String,
  },
  data() {
    return {
      isVisibility: false,
      rewardDescri: '',
      diyModalBg: [
        'static/runtime/images/magic/award/diyModalBg.png',
        'static/runtime/images/magic/award/awardBg2.png',
        'static/runtime/images/magic/award/tiger-bj.png',
        'static/runtime/images/magic/award/diyModalBg.png',
      ],
      diyModalHead: [
        'static/runtime/images/magic/award/zjjl_tc_bg.png',
        'static/runtime/images/magic/award/awardBg1.png',
        'static/runtime/images/magic/award/tiger-machine-head-bg.png',
        'static/runtime/images/magic/award/zjjl_tc_bg.png',
      ],
    };
  },
  created() {},
  mounted() {},
  computed: {
    getButtonBgStyle() {
      return {
        'background-color': this.activityObj.extendConfig.awardPopupButtonColor || '#ffffff',
      };
    },
  },
  methods: {
    openModel() {
      this.isVisibility = true;
    },
    modalOk() {
      this.isVisibility = false;
    },
    modalCancel() {
      this.isVisibility = false;
    },
    nextStep(link, type) {
      if (type === '9') {
        this.isVisibility = false;
      } else {
        this.$emit('nextStep', link, type);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.van-dialog {
  width: 100%;
  overflow: initial;
  background-color: transparent;
  /deep/ .van-dialog__content {
    margin: 0;
    padding: 0;
    width: 100%;
    height: 111vh;
    display: flex;
    align-items: center;
    justify-content: center;

    .diyModal {
      width: 320px;
      // max-width: 694px;
      height: auto;
      margin: auto;
      min-height: 245px;
      padding-bottom: 125px;
      position: relative;
      z-index: 10;
      .tiger-modal-bg {
      }
      .other-modal-bg {
        img {
          height: 210px;
        }
      }
      .diyModalBg {
        width: 100%;
        height: 210px;
        border-radius: 20px;
        position: absolute;
        bottom: 0;
        z-index: -1;
        overflow: hidden;
        &::before {
          content: '';
          width: 98%;
          height: 150px;
          position: absolute;
          bottom: 1px;
          background: #ffffff;
          border-radius: 26px;
        }
        img {
          width: 100%;
          position: absolute;
          bottom: -1px;
        }
      }
      .awardContent {
        width: 95%;
        min-height: 120px;
        margin: 0 2.5%;
        background: #ffffff;
        text-align: center;
        border-radius: 20px 20px 0 0;
      }
      .tiger-btn {
        font-family: HYQiHei-EES;
        color: #d7324c;
        font-size: 18px;
      }

      .diyReceive {
        width: 100%;
        height: 124px;
        position: absolute;
        bottom: 0;
        display: flex;
        justify-content: center;
        align-items: center;
        .tiger-btn-img {
          width: 90% !important;
          height: 80% !important;
        }
        .diyModalButton,
        .blindBoxBtn {
          width: 200px;
          height: 45px;
          margin-top: 33px;
          display: flex;
          justify-content: center;
          align-items: center;
          font-family: PingFangSC-Medium;
          font-size: 18px;
          color: #ffffff;
          position: relative;
          img,
          .diyModalButtonBg {
            width: 100%;
            height: 100%;
            position: absolute;
          }
          .diyModalButtonBg {
            background: #ffffff;
            border-radius: 36px;
          }
          .diyModalButtonText {
            width: 100%;
            height: 100%;
            position: absolute;
            div {
              width: 100%;
              height: 100%;
              display: flex;
              justify-content: center;
              align-items: center;
            }
          }
        }
        .blindBoxBtn {
          color: #b27d13 !important;
          font-size: 16px;
          height: 36px;
        }
      }
      .diyClose {
        width: 30px;
        height: 30px;
        font-size: 36px;
        position: absolute;
        left: 50%;
        transform: translate(-50%, 0);
        bottom: -50px;
        z-index: 10000;
        color: #ffffff;
      }
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/page/vibrantRubikCube/runtime/dynamicAttr/modal/pointModal.vue